import { render, staticRenderFns } from "./CountryList.vue?vue&type=template&id=35760b70&"
import script from "./CountryList.vue?vue&type=script&lang=js&"
export * from "./CountryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports